import { render, staticRenderFns } from "./SigepTabEquivalentsSidebar.vue?vue&type=template&id=ad24edde&scoped=true"
import script from "./SigepTabEquivalentsSidebar.vue?vue&type=script&lang=js"
export * from "./SigepTabEquivalentsSidebar.vue?vue&type=script&lang=js"
import style0 from "./SigepTabEquivalentsSidebar.vue?vue&type=style&index=0&id=ad24edde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad24edde",
  null
  
)

export default component.exports